import { CONTACT_REGEX } from '../../components/Contact/misc';
import { trimFinalSlash } from './trimFinalSlash';

export const prettifyUrl = (url: string | undefined): string | undefined =>
  !url ? url : trimFinalSlash(url.match(CONTACT_REGEX?.website)?.[1] || url);
